// @flow
import * as actions from './StudyActions'
import type { StudyStateT } from './StudyState.type'
import type { StudyT } from './Study.type'

type ActionT = {
  type: 'FETCH_STUDIES_SUCCESS',
  payload: Array<StudyT>
} | {
  type: 'FETCH_STUDIES_ERROR',
  payload: Error
} | {
  type: 'FETCH_STUDIES_LOADING'
}

export const studyReducer = (state: StudyStateT = {
  studies: {
    isFetching: false,
    error: null,
    data: null,
    lastFetched: null
  },
  newStudy: {
    isFetching: false,
    error: null,
    data: null,
    lastFetched: null
  },
  currentStudy: {
    isFetching: false,
    error: null,
    data: null,
    lastFetched: null
  },
  updateStudy: {
    isFetching: false,
    error: null,
    data: null,
    lastFetched: null
  },
  deleteStudy: {
    isFetching: false,
    error: null,
    data: null,
    lastFetched: null
  },
  updateStudyPhoto: {
    isFetching: false,
    error: null,
    data: null,
    lastFetched: null
  }
}, action: ActionT): StudyStateT => {
  switch (action.type) {
    case actions.FETCH_STUDIES_LOADING: {
      return {
        ...state,
        studies: {
          ...state.studies,
          isFetching: true,
          error: null
        }
      }
    }
    case actions.FETCH_STUDIES_SUCCESS: {
      const lastFetched = Date.now()
      return {
        ...state,
        studies: {
          ...state.studies,
          isFetching: false,
          lastFetched,
          data: action.payload,
          error: null
        }
      }
    }
    case actions.FETCH_STUDIES_ERROR: {
      const lastFetched = Date.now()
      return {
        ...state,
        studies: {
          ...state.studies,
          isFetching: false,
          lastFetched,
          error: action.payload
        }
      }
    }
    case actions.CREATE_STUDY_LOADING: {
      return {
        ...state,
        newStudy: {
          ...state.newStudy,
          isFetching: true,
          error: null
        }
      }
    }
    case actions.CREATE_STUDY_SUCCESS: {
      const lastFetched = Date.now()
      return {
        ...state,
        newStudy: {
          ...state.newStudy,
          isFetching: false,
          lastFetched,
          data: action.payload,
          error: null
        }
      }
    }
    case actions.CREATE_STUDY_ERROR: {
      const lastFetched = Date.now()
      return {
        ...state,
        newStudy: {
          ...state.newStudy,
          isFetching: false,
          lastFetched,
          error: action.payload
        }
      }
    }
    case actions.UPDATE_STUDY_LOADING: {
      return {
        ...state,
        updateStudy: {
          ...state.updateStudy,
          isFetching: true,
          error: null
        }
      }
    }
    case actions.UPDATE_STUDY_SUCCESS: {
      const lastFetched = Date.now()
      return {
        ...state,
        currentStudy: {
          ...state.currentStudy,
          isFetching: false,
          lastFetched,
          data: action.payload,
          error: null
        },
        updateStudy: {
          ...state.updateStudy,
          isFetching: false,
          lastFetched,
          data: action.payload,
          error: null
        }
      }
    }
    case actions.UPDATE_STUDY_ERROR: {
      const lastFetched = Date.now()
      return {
        ...state,
        updateStudy: {
          ...state.updateStudy,
          isFetching: false,
          lastFetched,
          error: action.payload
        }
      }
    }
    case actions.DELETE_STUDY_LOADING: {
      return {
        ...state,
        deleteStudy: {
          ...state.deleteStudy,
          isFetching: true,
          error: null,
          data: action.payload
        }
      }
    }
    case actions.DELETE_STUDY_SUCCESS: {
      const lastFetched = Date.now()
      return {
        ...state,
        deleteStudy: {
          ...state.deleteStudy,
          isFetching: false,
          lastFetched,
          data: null,
          error: null
        }
      }
    }
    case actions.DELETE_STUDY_ERROR: {
      const lastFetched = Date.now()
      return {
        ...state,
        deleteStudy: {
          ...state.deleteStudy,
          isFetching: false,
          lastFetched,
          error: action.payload
        }
      }
    }
    case actions.FETCH_STUDY_LOADING: {
      return {
        ...state,
        currentStudy: {
          ...state.currentStudy,
          isFetching: true,
          error: null
        }
      }
    }
    case actions.FETCH_STUDY_SUCCESS: {
      const lastFetched = Date.now()
      return {
        ...state,
        currentStudy: {
          ...state.currentStudy,
          isFetching: false,
          lastFetched,
          data: action.payload,
          error: null
        }
      }
    }
    case actions.FETCH_STUDY_ERROR: {
      const lastFetched = Date.now()
      return {
        ...state,
        currentStudy: {
          ...state.currentStudy,
          isFetching: false,
          lastFetched,
          error: action.payload
        }
      }
    }
    case actions.UPDATE_STUDY_PHOTO_LOADING: {
      return {
        ...state,
        updateStudyPhoto: {
          ...state.updateStudyPhoto,
          isFetching: true,
          error: null
        }
      }
    }
    case actions.UPDATE_STUDY_PHOTO_SUCCESS: {
      const lastFetched = Date.now()
      return {
        ...state,
        currentStudy: {
          ...state.currentStudy,
          isFetching: false,
          lastFetched,
          data: action.payload,
          error: null
        },
        updateStudyPhoto: {
          ...state.updateStudyPhoto,
          isFetching: false,
          lastFetched,
          data: action.payload,
          error: null
        }
      }
    }
    case actions.UPDATE_STUDY_PHOTO_ERROR: {
      const lastFetched = Date.now()
      return {
        ...state,
        updateStudyPhoto: {
          ...state.updateStudyPhoto,
          isFetching: false,
          lastFetched,
          error: action.payload
        }
      }
    }
    default:
      return state
  }
}
